import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ReportService } from '../report.service';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Component({
  selector: 'app-ia-marks-report',
  templateUrl: './ia-marks-report.component.html',
  styleUrls: ['./ia-marks-report.component.scss']
})
export class IAMarksReportComponent implements OnInit {
  IAReport: FormGroup;
  UserCollege: any;
  userPermission: any;
  userId: number | null = null;
  collegeList: any[] = [];
  filteredCollegeList: any[] = [];
  CourseList: any[] = [];
  filteredCourseList: any[] = [];
  ExamAList: any[] = [];
  filteredExamAList: any[] = [];
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  isDownloading = false;
  BranchList: any[] = [];
  filteredBranchList: any[] = [];

  selectedColleges: string[] = [];
  commaSeparatedColleges: string = '';

  showDownloadButton: boolean = false;
  showExcel = sessionStorage.getItem('TLoginName') === 'admin';
  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private reportService: ReportService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.fetchSessions();

    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission") || '[]');
    this.userId = this.userPermission.length
      ? this.userPermission[0].UserId
      : null;
  }

  initializeForm(): void {
    this.IAReport = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      course: new FormControl({ value: '', disabled: true }, Validators.required),
      college: new FormControl({ value: [], disabled: true }, Validators.required),
      Exam: new FormControl({ value: '', disabled: true }, Validators.required),
      Branch: new FormControl({ value: '', disabled: true }) // New Branch field
    });

    this.IAReport.get('SessionId').valueChanges.subscribe((value: string) => {
      console.log('Session changed to:', value);

      if (value) {
        this.IAReport.get('course').enable();
        this.fetchCourses();
        this.resetDependentFields(['college', 'Exam', 'Branch']);
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
      } else {
        this.IAReport.get('course').disable();
        this.IAReport.get('college').disable();
        this.IAReport.get('Exam').disable();
        this.IAReport.get('Branch').disable();

        this.resetDependentFields(['course', 'college', 'Exam', 'Branch']);
        this.CourseList = [];
        this.filteredCourseList = [];
        this.collegeList = [];
        this.filteredCollegeList = [];
        this.selectedColleges = [];
        this.BranchList = [];
        this.filteredBranchList = [];
      }

      this.updateDownloadButtonVisibility();
    });

    this.IAReport.get('course').valueChanges.subscribe((value: string) => {
      console.log('Course changed to:', value);

      if (value) {
        this.IAReport.get('college').enable();
        this.fetchColleges();
        this.resetDependentFields(['Exam', 'Branch']);
      } else {
        this.IAReport.get('college').disable();
        this.IAReport.get('college').setValue([]);
        this.resetDependentFields(['Exam', 'Branch']);
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.BranchList = [];
        this.filteredBranchList = [];
      }

      this.updateDownloadButtonVisibility();
    });

    this.IAReport.get('college').valueChanges.subscribe((value: string[]) => {
      console.log('Colleges changed to:', value);

      if (value && value.length > 0) {
        this.IAReport.get('Exam').enable();
        this.fetchExams();
      } else {
        this.IAReport.get('Exam').disable();
        this.IAReport.get('Exam').setValue('');
        this.IAReport.get('Branch').disable();
        this.IAReport.get('Branch').setValue('');
        this.BranchList = [];
        this.filteredBranchList = [];
      }

      this.updateDownloadButtonVisibility();
    });

    this.IAReport.get('Exam').valueChanges.subscribe((value: string) => {
      console.log('Exam changed to:', value);

      if (value) {
        this.IAReport.get('Branch').enable();
        this.fetchBranches();
      } else {
        this.IAReport.get('Branch').disable();
        this.IAReport.get('Branch').setValue('');
        this.BranchList = [];
        this.filteredBranchList = [];
      }

      this.updateDownloadButtonVisibility();
    });

    this.IAReport.get('Branch').valueChanges.subscribe((value: string) => {
      console.log('Branch changed to:', value);
      this.updateDownloadButtonVisibility();
    });
  }

  fetchSessions(): void {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe((res) => {
      if (res.status) {
        this.sessionList = res.data.filter((item: any) => item.SnStatus === 'O');
        this.SessionFilterList = this.sessionList.slice();
      } else {
        this.sessionList = [];
        this.SessionFilterList = [];
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching sessions:', error);
      this.spinner.hide();
    });
  }

  fetchCourses(): void {
    const sessionId = this.IAReport.get('SessionId').value;

    if (!sessionId) {
      console.warn('Cannot fetch courses: missing session');
      return;
    }

    this.spinner.show();

    const payload = {
      SessionID: sessionId
    };

    console.log('Fetching courses with payload:', payload);

    this.umsService.getSessionColgCo(payload).subscribe((res) => {
      if (res.status) {
        const uniqueCourses = res.data.filter((course: any, index: number, self: any[]) =>
          index === self.findIndex((c: any) => c.CoCgCoCode === course.CoCgCoCode)
        );

        this.CourseList = uniqueCourses;
        this.filteredCourseList = this.CourseList.slice();
        console.log('Courses fetched:', this.CourseList.length);
        this.IAReport.get('course').setValue('');
      } else {
        this.CourseList = [];
        this.filteredCourseList = [];
        console.warn('No courses found for session:', sessionId);
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching courses:', error);
      this.spinner.hide();
    });
  }

  fetchColleges(): void {
    const sessionId = this.IAReport.get('SessionId').value;
    const courseCode = this.IAReport.get('course').value;

    if (!sessionId || !courseCode) {
      console.warn('Cannot fetch colleges: missing session or course');
      return;
    }

    this.spinner.show();

    // Get user college permission
    this.UserCollege = this.userPermission[0]?.CgUi === 'C'
      ? this.userPermission[0].CgId
      : '';

    // Prepare payload for the new API - fetchstucourseClgMap
    const payload = {
      CoCode: courseCode
      // Note: The new API might not need sessionId, but we'll keep it if needed
      // SessionID: sessionId (optional if API supports it)
    };

    console.log('Fetching colleges with payload:', payload);

    this.umsService.fetchstucourseClgMap(payload).subscribe((res) => {
      if (res.status && res.data) {
        // Transform data if needed (assuming API returns similar structure)
        this.collegeList = res.data;

        // Apply user permission filtering if user has specific college access
        if (this.UserCollege) {
          this.collegeList = this.collegeList.filter(college =>
            college.CgCode === this.UserCollege
          );
        }

        this.filteredCollegeList = this.collegeList.slice();
        console.log('Colleges fetched:', this.collegeList.length);

        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.IAReport.get('college').setValue([]);
        if (this.collegeList.length === 1) {
          this.selectedColleges = [this.collegeList[0].CgCode];
          this.commaSeparatedColleges = this.selectedColleges.join(',');
          this.IAReport.get('college').setValue(this.selectedColleges);
          console.log('Auto-selected single college:', this.selectedColleges[0]);
        }

        if (this.collegeList.length === 0) {
          console.warn('No colleges found for course:', courseCode);
        }
      } else {
        this.collegeList = [];
        this.filteredCollegeList = [];
        console.warn('No colleges found for course:', courseCode);
        this.selectedColleges = [];
        this.commaSeparatedColleges = '';
        this.IAReport.get('college').setValue([]);
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching colleges:', error);
      this.collegeList = [];
      this.filteredCollegeList = [];
      this.selectedColleges = [];
      this.commaSeparatedColleges = '';
      this.IAReport.get('college').setValue([]);
      this.spinner.hide();
    });
  }


  fetchExams(): void {
    const courseCode = this.IAReport.get('course').value;
    const sessionId = this.IAReport.get('SessionId').value;

    if (!courseCode || !sessionId) {
      console.warn('Cannot fetch exams: missing course or session');
      return;
    }

    this.spinner.show();
    const payload = {
      EmCoCode: courseCode,
      SnNo: sessionId
    };

    console.log('Fetching exams with payload:', payload);

    this.umsService.getExam(payload).subscribe((res) => {
      if (res.status && res.data && res.data.length > 0) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
        console.log('Exams fetched:', this.ExamAList.length);
        const firstExamId = this.ExamAList[0].EmId;
        console.log('Auto-selecting first exam:', firstExamId);
        this.IAReport.get('Exam').setValue(firstExamId);

      } else {
        this.ExamAList = [];
        this.filteredExamAList = [];
        console.warn('No exams found for course:', courseCode);
        this.IAReport.get('Exam').setValue('');
      }
      this.spinner.hide();
      this.updateDownloadButtonVisibility();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching exams:', error);
      this.ExamAList = [];
      this.filteredExamAList = [];
      this.IAReport.get('Exam').setValue('');
      this.spinner.hide();
      this.updateDownloadButtonVisibility();
    });
  }

  fetchBranches(): void {
    const examId = this.IAReport.get('Exam').value;

    if (!examId) {
      console.warn('Cannot fetch branches: missing exam');
      return;
    }

    this.spinner.show();

    // First check if the exam has streams/branches
    const exam = this.ExamAList.find(e => e.EmId === examId);

    if (!exam || exam.EmStreams !== 'Y') {
      // No branches for this exam
      this.BranchList = [];
      this.filteredBranchList = [];
      this.IAReport.get('Branch').setValue('');
      this.IAReport.get('Branch').disable();
      this.spinner.hide();
      return;
    }

    const payload = {
      EmId: examId
    };

    console.log('Fetching branches with payload:', payload);

    this.umsService.getExamStream(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status && res.data) {
        this.BranchList = res.data;
        this.filteredBranchList = this.BranchList.slice();
        console.log('Branches fetched:', this.BranchList.length);

        if (this.BranchList.length > 0) {
          this.IAReport.get('Branch').setValue(this.BranchList[0].StrId);
        } else {
          this.IAReport.get('Branch').setValue('');
        }

        if (this.BranchList.length === 0) {
          console.warn('No branches found for exam:', examId);
          // Disable branch selection if no branches available
          this.IAReport.get('Branch').disable();
        }
      } else {
        this.BranchList = [];
        this.filteredBranchList = [];
        this.IAReport.get('Branch').setValue('');
        console.warn('No branches found for exam:', examId);
        this.IAReport.get('Branch').disable();
      }
      this.updateDownloadButtonVisibility();
    }, (error: HttpErrorResponse) => {
      console.error('Error fetching branches:', error);
      this.BranchList = [];
      this.filteredBranchList = [];
      this.IAReport.get('Branch').setValue('');
      this.IAReport.get('Branch').disable();
      this.spinner.hide();
      this.updateDownloadButtonVisibility();
    });
  }

  selectAllColleges(): void {
    if (this.isAllSelected()) {
      this.selectedColleges = [];
      this.IAReport.get('college').setValue([], { emitEvent: false });
      this.commaSeparatedColleges = '';
      this.IAReport.get('Exam').disable();
      this.IAReport.get('Exam').setValue('');
      this.IAReport.get('Branch').disable();
      this.IAReport.get('Branch').setValue('');
    } else {
      this.selectedColleges = this.filteredCollegeList.map(item => item.CgCode);
      this.IAReport.get('college').setValue(this.selectedColleges, { emitEvent: false });
      this.commaSeparatedColleges = this.selectedColleges.join(',');

      this.IAReport.get('Exam').enable();
    }
    this.updateDownloadButtonVisibility();
  }

  onCollegeSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];

    selected = selected.filter((item: any) => item !== 'selectAll');

    this.selectedColleges = selected;
    this.IAReport.get('college').setValue(selected, { emitEvent: false });
    this.commaSeparatedColleges = this.selectedColleges.join(',');

    if (selected.length > 0) {
      this.IAReport.get('Exam').enable();
    } else {
      this.IAReport.get('Exam').disable();
      this.IAReport.get('Exam').setValue('');
      this.IAReport.get('Branch').disable();
      this.IAReport.get('Branch').setValue('');
    }

    this.updateDownloadButtonVisibility();
  }

  isAllSelected(): boolean {
    return this.selectedColleges.length === this.filteredCollegeList.length && this.filteredCollegeList.length > 0;
  }

  isAllCollegesSelected(): boolean {
    return this.isAllSelected();
  }

  isIndeterminate(): boolean {
    return this.selectedColleges.length > 0 && this.selectedColleges.length < this.filteredCollegeList.length;
  }

  canSelectExam(): boolean {
    const hasSession = !!this.IAReport.get('SessionId').value;
    const hasCourse = !!this.IAReport.get('course').value;
    const hasColleges = this.IAReport.get('college').value &&
      this.IAReport.get('college').value.length > 0;

    return hasSession && hasCourse && hasColleges;
  }
  downloadIAReport(): void {
    if (this.IAReport.invalid) {
      this.markFormGroupTouched(this.IAReport);
      return;
    }

    this.isDownloading = true;
    const formData = this.IAReport.value;

    const collegeCodes = this.commaSeparatedColleges ||
      (Array.isArray(formData.college) ? formData.college.join(',') : formData.college);

    // Get branch value, default to "0" if not selected
    const branchValue = formData.Branch || "0";

    const payload1 = {
      SessionID: formData.SessionId,
      CoCode: formData.course,
      CgCode: collegeCodes,
      EmId: formData.Exam,
      StrId: branchValue // StrId represents the branch
    };

    console.log('Downloading PDF report with payload:', payload1);

    let jsonString = JSON.stringify(payload1);
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 302,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": 0,
      "CsNo": '',
      "PgBreak": '',
      "StrId": branchValue, // StrId for branch in filter
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": payload1.SessionID,
      "Extra1": jsonString,
      "Mode": true
    }

    var payload: any;
    payload = filter;
    // this.umsService.setData(JSON.stringify(payload));
    // this.router.navigate(['hbsreports']);
      this.reportService.generateHbsReport(payload);
    
    setTimeout(() => {
      this.isDownloading = false;
    }, 1000);
  }

  downloadIAMarksReportExcel() {
    if (this.IAReport.invalid) {
      this.markFormGroupTouched(this.IAReport);
      return;
    }

    this.spinner.show();

    const formValue = this.IAReport.value;

    const cgCode = this.userPermission[0]?.CgUi === 'C'
      ? this.userPermission[0].CgId
      : this.commaSeparatedColleges || (Array.isArray(formValue.college) ? formValue.college.join(',') : formValue.college);

    const branchValue = formValue.Branch || "0";

    const payload = {
      SessionID: formValue.SessionId,
      CoCode: formValue.course,
      CgCode: cgCode,
      EmId: formValue.Exam,
      StrId: branchValue // Changed from Branch to StrId for consistency
    };

    console.log('Downloading Excel report with payload:', payload);

    this.umsService.getIAMarksReport(payload).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (!res.status || !res.data?.length) {
          alert('No IA Marks data available!');
          return;
        }

        const data = res.data;

        interface SubjectHeader {
          key: string;
          MainSubjectName: string;
          SubjectName: string;
          EsMaxMarks: number;
        }

        const subjectMap = new Map<string, SubjectHeader[]>();

        data.forEach((r: any) => {
          const subject = r.MainSubjectName;
          const key = `${r.MainSubjectName}__${r.SubjectName}`;

          if (!subjectMap.has(subject)) {
            subjectMap.set(subject, []);
          }

          const list = subjectMap.get(subject)!;

          if (!list.some(s => s.key === key)) {
            list.push({
              key,
              MainSubjectName: r.MainSubjectName,
              SubjectName: r.SubjectName,
              EsMaxMarks: r.EsMaxMarks
            });
          }
        });

        subjectMap.forEach(list => {
          list.sort((a, b) => a.SubjectName.localeCompare(b.SubjectName));
        });

        const subjects: SubjectHeader[] = [];
        subjectMap.forEach(list => subjects.push(...list));

        const studentMap = new Map<string, any>();

        data.forEach((row: any) => {
          if (!studentMap.has(row.StuRgNo)) {
            studentMap.set(row.StuRgNo, {
              CourseCode: row.CoCode,
              course: row.CoName,
              exam: row.EmName,
              collegeCode: row.CgCode,
              college: row.CollegeName,
              prn: row.StuRgNo,
              seat: row.RollNo,
              name: row.StudentName,
              tuSign: row.StuSign || '',
              marks: {}
            });
          }

          const key = `${row.MainSubjectName}__${row.SubjectName}`;
          studentMap.get(row.StuRgNo).marks[key] = row.Marks;
        });

        const headerRow1 = [
          'Course Code',
          'Course Name',
          'Exam Name',
          'College Code',
          'College Name',
          'PRN No',
          'Seat No',
          'Student Name',
        ];

        const headerRow2 = ['', '', '', '', '', '', '', ''];
        const headerRow3 = ['', '', '', '', '', '', '', ''];

        subjects.forEach(s => {
          headerRow1.push(s.MainSubjectName);
          headerRow2.push(s.SubjectName);
          headerRow3.push(`${s.EsMaxMarks} Marks`);
        });

        headerRow1.push('Student Sign');
        headerRow2.push('');
        headerRow3.push('');

        const dataRows = Array.from(studentMap.values()).map(stu => {
          const row = [
            stu.CourseCode,
            stu.course,
            stu.exam,
            stu.collegeCode,
            stu.college,
            stu.prn,
            stu.seat,
            stu.name
          ];

          subjects.forEach(s => {
            row.push(stu.marks[s.key] ?? '');
          });
          row.push(stu.tuSign);
          return row;
        });

        const worksheet = XLSX.utils.aoa_to_sheet([
          headerRow1,
          headerRow2,
          headerRow3,
          ...dataRows
        ]);
        worksheet['!merges'] = [];

        let colStart = 8;

        for (let i = 0; i < subjects.length;) {
          let j = i;
          while (
            j < subjects.length &&
            subjects[j].MainSubjectName === subjects[i].MainSubjectName
          ) {
            j++;
          }

          if (j - i > 1) {
            worksheet['!merges'].push({
              s: { r: 0, c: colStart + i },
              e: { r: 0, c: colStart + j - 1 }
            });
          }

          i = j;
        }

        const workbook: XLSX.WorkBook = {
          Sheets: { 'IA Marks': worksheet },
          SheetNames: ['IA Marks']
        };

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        saveAs(
          new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }),
          `IA_Marks_${new Date().toISOString().slice(0, 10)}.xlsx`
        );
      },
      (error) => {
        this.spinner.hide();
        console.error('Error downloading IA Marks:', error);
        alert('Error while downloading IA Marks!');
      }
    );
  }


  private updateDownloadButtonVisibility(): void {
    const formValues = this.IAReport.value;
    this.showDownloadButton =
      !!formValues.SessionId &&
      !!formValues.course &&
      formValues.college &&
      formValues.college.length > 0 &&
      !!formValues.Exam;

    console.log('Download button visibility:', this.showDownloadButton, {
      session: !!formValues.SessionId,
      course: !!formValues.course,
      college: formValues.college?.length > 0,
      exam: !!formValues.Exam,
      branch: formValues.Branch,
      examValue: formValues.Exam
    });
  }

  private resetDependentFields(fieldsToReset: string[]): void {
    fieldsToReset.forEach(field => {
      const control = this.IAReport.get(field);
      if (control) {
        control.setValue('');

        switch (field) {
          case 'course':
            this.CourseList = [];
            this.filteredCourseList = [];
            break;
          case 'college':
            this.selectedColleges = [];
            this.commaSeparatedColleges = '';
            this.collegeList = [];
            this.filteredCollegeList = [];
            break;
          case 'Exam':
            this.ExamAList = [];
            this.filteredExamAList = [];
            break;
          case 'Branch':
            this.BranchList = [];
            this.filteredBranchList = [];
            break;
        }
      }
    });
    this.updateDownloadButtonVisibility();
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getCollegeName(collegeCode: string): string {
    const college = this.collegeList.find(c => c.CgCode === collegeCode);
    return college ? college.CgName : collegeCode;
  }

  getCourseName(courseCode: string): string {
    const course = this.CourseList.find(c => c.CoCgCoCode === courseCode);
    return course ? course.CoName : courseCode;
  }

  getExamName(examId: string): string {
    const exam = this.ExamAList.find(e => e.EmId === examId);
    return exam ? exam.EmName : examId;
  }

  getSessionName(sessionId: string): string {
    const session = this.sessionList.find(s => s.SnNo === sessionId);
    return session ? session.SnName : sessionId;
  }

  getBranchName(branchId: string): string {
    const branch = this.BranchList.find(b => b.StrId === branchId);
    return branch ? branch.StrName : branchId;
  }

  // Helper method to check if branch selection should be shown
  showBranchField(): boolean {
    const examId = this.IAReport.get('Exam').value;
    if (!examId) return false;

    const exam = this.ExamAList.find(e => e.EmId === examId);
    return exam ? exam.EmStreams === 'Y' : false;
  }

  // Method to handle exam change and fetch branches
  onExamChange(examId: string): void {
    if (examId) {
      this.fetchBranches();
    } else {
      this.BranchList = [];
      this.filteredBranchList = [];
      this.IAReport.get('Branch').setValue('');
      this.IAReport.get('Branch').disable();
    }
  }
}